import { Component, ChangeDetectionStrategy } from '@angular/core';
import { FieldWrapper } from '@ngx-formly/core';

@Component({
  selector: 'formly-wrapper-modern-switch',
  standalone: false,
  templateUrl: './modern-switch-wrapper.component.html',
  styleUrl: '../../styles/modern-page-layout.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FormlyWrapperModernSwitch extends FieldWrapper {
  get switchLabel(): string {
    const value = this.formControl.value;
    const labels = this.props.switchLabels || { checked: 'On', unchecked: 'Off' };
    return value ? labels.checked : labels.unchecked;
  }
}
